// For User List

export const GET_ALL_USER_LIST_DATA = 'GET_ALL_USER_LIST_DATA';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const SET_GRID_DATA = 'SET_GRID_DATA_USERLIST';
